import { render, staticRenderFns } from "./ReturnOrderList.vue?vue&type=template&id=be76899e&scoped=true"
import script from "./ReturnOrderList.vue?vue&type=script&lang=ts"
export * from "./ReturnOrderList.vue?vue&type=script&lang=ts"
import style0 from "./ReturnOrderList.vue?vue&type=style&index=0&id=be76899e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be76899e",
  null
  
)

export default component.exports